/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svd_Request_CasesInputs */

const en_svd_request_cases = /** @type {(inputs: Svd_Request_CasesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Request case studies`)
};

const ar_svd_request_cases = /** @type {(inputs: Svd_Request_CasesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اطلب دراسات الحالة`)
};

const bn_svd_request_cases = /** @type {(inputs: Svd_Request_CasesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কেস স্টাডি চেয়ে নিন`)
};

const de_svd_request_cases = /** @type {(inputs: Svd_Request_CasesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fallstudien anfordern`)
};

const es_svd_request_cases = /** @type {(inputs: Svd_Request_CasesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solicitar estudios de casos`)
};

const fr_svd_request_cases = /** @type {(inputs: Svd_Request_CasesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demander des études de cas`)
};

const pt_svd_request_cases = /** @type {(inputs: Svd_Request_CasesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solicite estudos de caso`)
};

const zh_svd_request_cases = /** @type {(inputs: Svd_Request_CasesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请求案例研究`)
};

const tr_svd_request_cases = /** @type {(inputs: Svd_Request_CasesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Örnek olay incelemeleri isteyin`)
};

const ru_svd_request_cases = /** @type {(inputs: Svd_Request_CasesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Запросить тематические исследования`)
};

const pl_svd_request_cases = /** @type {(inputs: Svd_Request_CasesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poproś o studia przypadków`)
};

/**
* | output |
* | --- |
* | "Request case studies" |
*
* @param {Svd_Request_CasesInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svd_request_cases = /** @type {((inputs?: Svd_Request_CasesInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svd_Request_CasesInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svd_request_cases(inputs)
	if (locale === "bn") return bn_svd_request_cases(inputs)
	if (locale === "de") return de_svd_request_cases(inputs)
	if (locale === "es") return es_svd_request_cases(inputs)
	if (locale === "fr") return fr_svd_request_cases(inputs)
	if (locale === "pt") return pt_svd_request_cases(inputs)
	if (locale === "zh") return zh_svd_request_cases(inputs)
	if (locale === "tr") return tr_svd_request_cases(inputs)
	if (locale === "ru") return ru_svd_request_cases(inputs)
	if (locale === "pl") return pl_svd_request_cases(inputs)
	return en_svd_request_cases(inputs)
});